import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { APP_VERSION, formatBuildDate } from "@/lib/build-info";

export default function Confidentialite() {
  return (
    <div className="min-h-screen bg-cream-50 text-plum-900">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-[13px] font-semibold text-plum-700/70 hover:text-plum-700 mb-8" data-testid="legal-back">
          <ArrowLeft size={14} /> Retour à l&apos;accueil
        </Link>
        <h1 className="heading-display text-3xl sm:text-4xl mb-2">Politique de confidentialité</h1>
        <p className="text-[13px] text-plum-700/55 mb-10">Version {APP_VERSION} · mise à jour le {formatBuildDate()}</p>

        <section className="space-y-8 text-[15px] leading-relaxed text-plum-700/85">
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Données collectées</h2>
            <p>
              Istres &amp; Moi collecte les informations strictement nécessaires au fonctionnement du service : nom, email, pseudonyme, rôle (habitant/commerçant/mairie), et — si vous y consentez — votre géolocalisation lors d'un signalement.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Finalité</h2>
            <p>
              Vos données servent à traiter les remontées, sondages, quiz et bons d'achat. Elles ne sont jamais cédées à des tiers commerciaux.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Durée de conservation</h2>
            <p>
              Compte conservé tant qu'il reste actif ; remontées et signalements conservés 3 ans à des fins de suivi municipal.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Vos droits (RGPD)</h2>
            <p>
              Vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement et de portabilité de vos données. Contactez la mairie d&apos;Istres pour exercer ces droits.
            </p>
          </div>
          <div>
            <h2 className="font-display font-bold text-lg text-plum-900 mb-2">Cookies</h2>
            <p>
              Seuls des cookies techniques (session de connexion) sont utilisés. Aucun cookie publicitaire ni de tracking.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
